<div class="grid-x">
  <div class="cell large-12 medium-12 small-12 bold">
    <div class="section-header" [ngClass]="{ 'active' : step == activeStep }" (click)="toggleOpen()">
      <span class="margin-right">Step 3: Well Information</span>
      <button class="icon-button">
        @if (isOpen == false) {
          <svg-icon icon="icon-caret-right"></svg-icon>
        }
        @if (isOpen == true) {
          <svg-icon icon="icon-caret-down"></svg-icon>
        }
      </button>
    </div>
  </div>
</div>
<div class="grid-x margin-top" [formGroup]="form" [ngClass]="{ 'hideSection': isOpen == false }">
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    Well Name<span [ngClass]="{ 'red': form?.get('name')?.invalid }">*</span>:
    @if (fieldHasNotes('wellInformation|name') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'wellInformation|name'" [notes]="getFilteredNotes('wellInformation|name')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="text" formControlName="name" />
  </div>
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    Well Number<span [ngClass]="{ 'red': form?.get('number')?.invalid }">*</span>:
    @if (fieldHasNotes('wellInformation|number') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'wellInformation|number'" [notes]="getFilteredNotes('wellInformation|number')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="text" formControlName="number" />
  </div>
  <div class="cell large-3 medium-32 small-6 bold padding-right text-align-right">
    <help-text [helpText]="coordinateHelpText"></help-text><span class="padding-left">Surface Latitude</span><span [ngClass]="{ 'red': form?.get('surfaceLatitude')?.invalid }">*</span>:
    @if (fieldHasNotes('wellInformation|surfaceLatitude') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'wellInformation|surfaceLatitude'" [notes]="getFilteredNotes('wellInformation|surfaceLatitude')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="number" formControlName="surfaceLatitude" (blur)="roundCoordinate('surfaceLatitude')" />
  </div>
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    <help-text [helpText]="coordinateHelpText"></help-text><span class="padding-left">Surface Longitude</span><span [ngClass]="{ 'red': form?.get('surfaceLongitude')?.invalid }">*</span>:
    @if (fieldHasNotes('wellInformation|surfaceLongitude') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'wellInformation|surfaceLongitude'" [notes]="getFilteredNotes('wellInformation|surfaceLongitude')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="number" formControlName="surfaceLongitude" (blur)="roundCoordinate('surfaceLongitude')" />
  </div>
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    <help-text [helpText]="coordinateHelpText"></help-text><span class="padding-left">Target Latitude</span>@if (orientation !== 'Vertical') {
    <span [ngClass]="{ 'red': form?.get('targetLatitude')?.invalid }">*</span>
    }:
    @if (fieldHasNotes('wellInformation|targetLatitude') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'wellInformation|targetLatitude'" [notes]="getFilteredNotes('wellInformation|targetLatitude')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="number" formControlName="targetLatitude" (blur)="roundCoordinate('targetLatitude')" />
  </div>
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    <help-text [helpText]="coordinateHelpText"></help-text><span class="padding-left">Target Longitude</span>@if (orientation !== 'Vertical') {
    <span [ngClass]="{ 'red': form?.get('targetLongitude')?.invalid }">*</span>
    }:
    @if (fieldHasNotes('wellInformation|targetLongitude') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'wellInformation|targetLongitude'" [notes]="getFilteredNotes('wellInformation|targetLongitude')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="number" formControlName="targetLongitude" (blur)="roundCoordinate('targetLongitude')" />
  </div>
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    Surface Elevation<span [ngClass]="{ 'red': form?.get('surfaceElevation')?.invalid }">*</span>:
    @if (fieldHasNotes('wellInformation|surfaceElevation') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'wellInformation|surfaceElevation'" [notes]="getFilteredNotes('wellInformation|surfaceElevation')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="number" formControlName="surfaceElevation" />
  </div>
  <div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
    Proposed Total Depth:<span [ngClass]="{ 'red': form?.get('proposedTotalDepth')?.invalid }">*</span>:
    @if (fieldHasNotes('wellInformation|proposedTotalDepth') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'wellInformation|proposedTotalDepth'" [notes]="getFilteredNotes('wellInformation|proposedTotalDepth')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="number" formControlName="proposedTotalDepth" />
  </div>
  <div class="cell large-5 medium-5 small-6 padding-right text-align-right bold">
    Proposed Geological Formation(s) to be tested<span [ngClass]="{ 'red': form?.get('proposedFormation')?.invalid }">*</span>:
    @if (fieldHasNotes('wellInformation|proposedFormation') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'wellInformation|proposedFormation'" [notes]="getFilteredNotes('wellInformation|proposedFormation')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-7 medium-7 small-6">
    <ng-select id="formationSelector" formControlName="proposedFormation" class="limit-select" [multiple]="true" [items]="formations" bindLabel="definition" bindValue="code"></ng-select>
  </div>
  <!--<div class="cell large-6 medium-6 small-6 padding-right text-align-right bold">
  Are there any surface rights owned by the State of Ohio in this unit<span [ngClass]="{ 'red': form?.get('surfaceRights')?.invalid }">*</span>?
  <span class="padding-left" *ngIf="fieldHasNotes('wellInformation|surfaceRights') || reviewStates?.includes(applicationState)">
    <view-notes [fieldName]="'wellInformation|surfaceRights'" [notes]="getFilteredNotes('wellInformation|surfaceRights')" (notesRequested)="handleNoteRequested($event)"></view-notes>
  </span>
</div>
<div class="cell large-6 medium-6 small-6 text-align-left padding-left">
  <span><input type="radio" formControlName="surfaceRights" value="false" (ngModelChange)="surfaceRightsChanged($event)" /> No</span><br />
  <span><input type="radio" formControlName="surfaceRights" value="true" (ngModelChange)="surfaceRightsChanged($event)" /> Yes</span>
</div>
<div class="cell large-3 medium-3 small-6 padding-right text-align-right bold">
  Name of Agency<span *ngIf="form?.get('surfaceRights')?.value == 'true'" [ngClass]="{ 'red': form?.get('agency')?.invalid }">*</span>:
  <span class="padding-left" *ngIf="fieldHasNotes('wellInformation|agency') || reviewStates?.includes(applicationState)">
    <view-notes [fieldName]="'wellInformation|agency'" [notes]="getFilteredNotes('wellInformation|agency')" (notesRequested)="handleNoteRequested($event)"></view-notes>
  </span>
</div>
<div class="cell large-9 medium-9 small-6">
  <ng-select id="agencySelector" formControlName="agency" class="limit-select" [multiple]="true" [items]="agencies" bindLabel="Definition" bindValue="Code"></ng-select>
</div>-->
<div class="cell large-8 medium-8 small-8 text-align-right padding-right bold">
  Validate Surface Coordinates in GIS (required to determine permit fees):
  <span class="padding-left">
    @if (form?.get('surfaceGISValidationRun')?.valid) {
      <svg-icon class="large green" icon="icon-checkbox"></svg-icon>
    }
    @if (form?.get('surfaceGISValidationRun')?.invalid) {
      <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
    }
  </span>
</div>
<div class="cell large-2 medium-2 small-2 padding-left padding-right">
  <button class="button full-width" (click)="validateSurface(pointTypes.WellHead)" [disabled]="disableValidateButton">Validate</button>
</div>
<div class="cell large-2 medium-2 small-2">&nbsp;</div>
<div class="cell large-2 medium-2 small-6 bold padding-right text-align-right">
  County:
  @if (fieldHasNotes('wellInformation|countyName') || reviewStates?.includes(applicationState)) {
    <span class="padding-left">
      <view-notes [fieldName]="'wellInformation|countyName'" [notes]="getFilteredNotes('wellInformation|countyName')" (notesRequested)="handleNoteRequested($event)"></view-notes>
    </span>
  }
</div>
<div class="cell large-4 medium-4 small-6 padding-left">
  <input type="text" formControlName="countyName" />
</div>
<div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
  City / Village / Township:
  @if (fieldHasNotes('wellInformation|civilTownship') || reviewStates?.includes(applicationState)) {
    <span class="padding-left">
      <view-notes [fieldName]="'wellInformation|civilTownship'" [notes]="getFilteredNotes('wellInformation|civilTownship')" (notesRequested)="handleNoteRequested($event)"></view-notes>
    </span>
  }
</div>
<div class="cell large-3 medium-3 small-6 padding-left">
  <input type="text" formControlName="civilTownship" />
</div>
<div class="cell large-2 medium-2 small-6 bold padding-right text-align-right">
  Section:
  @if (fieldHasNotes('wellInformation|section') || reviewStates?.includes(applicationState)) {
    <span class="padding-left">
      <view-notes [fieldName]="'wellInformation|section'" [notes]="getFilteredNotes('wellInformation|section')" (notesRequested)="handleNoteRequested($event)"></view-notes>
    </span>
  }
</div>
<div class="cell large-4 medium-4 small-6 padding-left">
  <input type="text" formControlName="section" />
</div>
<div class="cell large-3 medium-3 small-6 bold padding-right text-align-right">
  Lot:
  @if (fieldHasNotes('wellInformation|lot') || reviewStates?.includes(applicationState)) {
    <span class="padding-left">
      <view-notes [fieldName]="'wellInformation|lot'" [notes]="getFilteredNotes('wellInformation|lot')" (notesRequested)="handleNoteRequested($event)"></view-notes>
    </span>
  }
</div>
<div class="cell large-3 medium-3 small-6 padding-left">
  <input type="text" formControlName="lot" />
</div>
</div>